import React, { useState, useEffect } from "react";

import FaceButton from "./FaceButton";
import sad from "../../resources/icons/sad.png";
import unhappy from "../../resources/icons/unhappy.png";
import meh from "../../resources/icons/meh.png";
import happy from "../../resources/icons/happy.png";
import excited from "../../resources/icons/excited.png";

const style = {
  smallText: {
    fontFamily: "Poppins-Regular",
    fontSize: 11,
    marginTop: 3,
  },
};

export default (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "center",
          width: 400,
        }}
      >
        <FaceButton
          rating={props.rating}
          setRating={props.setRating}
          value={1}
          img={sad}
        />
        <FaceButton
          rating={props.rating}
          setRating={props.setRating}
          value={2}
          img={unhappy}
        />
        <FaceButton
          rating={props.rating}
          setRating={props.setRating}
          value={3}
          img={meh}
        />
        <FaceButton
          rating={props.rating}
          setRating={props.setRating}
          value={4}
          img={happy}
        />
        <FaceButton
          rating={props.rating}
          setRating={props.setRating}
          value={5}
          img={excited}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "center",
          marginBottom: 25,
          width: 400,
        }}
      >
        <span style={style.smallText}>Very Unsatisfied</span>
        <span style={style.smallText}>Very Satisfied</span>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/survey/FaceSelector.js